/**
 * La forme du détail d'une quête pendant son premier chargement : la carte de l'étape en cours,
 * puis les étapes à venir sous leur intitulé, dans les colonnes de la page. Le cas montré est le
 * cas courant : une quête entamée, des étapes devant soi.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { columnStyles } from "../../atoms/containers/columns"
import { Stack } from "../../atoms/containers/Stack"
import { SectionLabel } from "../../atoms/typography/SectionLabel"
import { CardList } from "../../molecules/CardList"
import { QuestStepRowSkeleton } from "../../molecules/QuestStepRow"
import { QuestCardSkeleton } from "../../organisms/QuestCard"
import { QUEST_DETAIL_TEXTS } from "./questDetailTexts"

export function StudentQuestDetailSkeleton() {
    return (
        <View style={[columnStyles.columns, styles.fullWidth]}>
            <Stack gap="4" style={columnStyles.column}>
                <QuestCardSkeleton hero />
            </Stack>
            <Stack gap="2" style={columnStyles.column}>
                <SectionLabel>{QUEST_DETAIL_TEXTS.locked}</SectionLabel>
                <CardList>
                    <QuestStepRowSkeleton />
                    <QuestStepRowSkeleton />
                    <QuestStepRowSkeleton />
                    <QuestStepRowSkeleton />
                </CardList>
            </Stack>
        </View>
    )
}

const styles = StyleSheet.create(() => ({
    fullWidth: { width: "100%" },
}))
